'use es6';

import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Set as ImmutableSet } from 'immutable';
import { AddIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import { LOADING } from 'reporting-action-components/reportingActions/problems';
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import { getReports } from '../../actions/reportsActions';
import { getQueryParamsObject } from '../../utils/queryStrings';
import { selectedRowsActions } from '../../redux/selectedRows';
import { selectFilteredReportCount, selectQueryFilters } from '../../selectors/reportsSelector';
import { ADD_TO_DASHBOARD_DIALOG } from 'reporting-action-components/dialog/dialogTypes';
import { ReportingTracker } from '../../lib/usageTracker';
import useAddReportsToAnyDashboardProblem from 'reporting-action-components/reportingActions/addReportToDashboard/useAddReportsToAnyDashboardProblem';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useHandleAddToDashboard = ({
  selectedRows,
  selectedEverything,
  filteredReportCount
}) => {
  const filters = useSelector(selectQueryFilters);
  const reports = !selectedEverything ? selectedRows : ImmutableSet();
  const showDialog = useShowDialog();
  const dispatch = useDispatch();
  const trackClick = () => {
    trackEvent(EVENTS.addToDashboardInteraction, {
      actionType: 'edit',
      action: 'add-to-dashboard',
      assetType: 'report',
      step: 'start',
      count: selectedEverything ? filteredReportCount : selectedRows.size
    });
  };
  const {
    dashboardId: dashboardIdQueryParam
  } = getQueryParamsObject();
  const defaultDashboardTargetId = dashboardIdQueryParam && Number(dashboardIdQueryParam);
  const onAdd = dashboardId => {
    if (defaultDashboardTargetId && dashboardId === defaultDashboardTargetId) {
      // Redirect back to the dashboard view, and avoid updating redux state, when the 'add report' flow originates from
      // the 'add report' dropdown action 'from my reports' in the dashboard view
      window.location = `/reports-dashboard/${PortalIdParser.get()}/view/${defaultDashboardTargetId}`;
    } else {
      dispatch(selectedRowsActions.clearSelectedRows());
      dispatch(getReports());
    }
  };
  return () => {
    trackClick();
    showDialog({
      dialogType: ADD_TO_DASHBOARD_DIALOG,
      dialogProps: {
        appUsageTracker: ReportingTracker,
        reports,
        onAddToDashboardSuccess: onAdd,
        filteredReportCount,
        filters
      }
    });
  };
};
const BulkAddToDashboardAction = props => {
  const {
    selectedRows,
    selectedEverything
  } = props;
  const filteredReportCount = useSelector(selectFilteredReportCount);
  const handleAddToDashboard = useHandleAddToDashboard({
    selectedRows,
    selectedEverything,
    filteredReportCount
  });
  const {
    problem,
    disabledMessage
  } = useAddReportsToAnyDashboardProblem({
    reports: selectedRows
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledMessage,
    disabled: !!problem,
    children: /*#__PURE__*/_jsx(Link, {
      onClick: handleAddToDashboard,
      disabled: selectedEverything || !!problem,
      "data-test-id": problem !== LOADING.toString() && 'report-bulk-add-report',
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: 200,
        children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.table.header.addToDashboard"
        })]
      })
    })
  });
};
BulkAddToDashboardAction.propTypes = {
  selectedRows: PropTypes.instanceOf(ImmutableSet).isRequired,
  selectedEverything: PropTypes.bool.isRequired
};
export default BulkAddToDashboardAction;